import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE, delay: i * 0.09 },
  }),
};

export const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

export function Reveal({ children, className, delay = 0, ...rest }) {
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-70px" }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.28em] ${
        dark ? "text-slate-400" : "text-slate-500"
      }`}
    >
      <span className="h-px w-8 bg-gradient-to-r from-blue-600 to-violet-600" />
      {children}
    </span>
  );
}
